// 'use client';

// // import { useMemo, useState } from 'react';
// // import styles from './styles.module.css';

// // const WEEK_DAYS = ['یک‌شنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه', 'شنبه'];

// // function getTehranWeek() {
// //   const now = new Date();

// //   // Get today's date in Tehran
// //   const tehranToday = new Date(
// //     now.toLocaleString('en-US', {
// //       timeZone: 'Asia/Tehran',
// //     }),
// //   );

// //   return Array.from({ length: 7 }, (_, index) => {
// //     const date = new Date(tehranToday);
// //     date.setDate(tehranToday.getDate() + index);

// //     const dateLabel = new Intl.DateTimeFormat('fa-IR', {
// //       timeZone: 'Asia/Tehran',
// //       day: 'numeric',
// //       month: 'long',
// //     }).format(date);

// //     let dayLabel;

// //     if (index === 0) {
// //       dayLabel = 'امروز';
// //     } else if (index === 1) {
// //       dayLabel = 'فردا';
// //     } else {
// //       dayLabel = WEEK_DAYS[date.getDay()];
// //     }

// //     return {
// //       id: index,
// //       dayLabel,
// //       dateLabel,
// //       slots: Math.floor(Math.random() * 8) + 2, // replace with API value
// //     };
// //   });
// // }

// // export default function WeekSelector() {
// //   const days = useMemo(() => getTehranWeek(), []);
// //   const [selected, setSelected] = useState(0);

// //   return (
// //     <div className={styles.container}>
// //       {days.map((day) => (
// //         <button
// //           key={day.id}
// //           className={`${styles.button} ${selected === day.id ? styles.active : ''}`}
// //           onClick={() => setSelected(day.id)}
// //         >
// //           <div className={`${styles.day} ${selected === day.id ? styles.activeText : ''}`}>
// //             {day.dayLabel}
// //           </div>

// //           <div className={`${styles.date} ${selected === day.id ? styles.activeText : ''}`}>
// //             {day.dateLabel}
// //           </div>

// //           <div className={styles.slots}>{day.slots} نوبت</div>
// //         </button>
// //       ))}
// //     </div>
// //   );
// // }

// // ================
// // 'use client';
// // import { useMemo, useState } from 'react';
// // import moment from 'moment-jalaali';
// // import 'moment-timezone';
// // import styles from './styles.module.css';

// // moment.loadPersian({
// //   dialect: 'persian-modern',
// //   usePersianDigits: true,
// // });

// // function getTehranWeek() {
// //   const today = moment().tz('Asia/Tehran');

// //   return Array.from({ length: 7 }, (_, index) => {
// //     const date = today.clone().add(index, 'day');

// //     return {
// //       id: index,
// //       dayLabel: index === 0 ? 'امروز' : index === 1 ? 'فردا' : date.format('dddd'),
// //       dateLabel: date.format('jD jMMMM'),
// //       slots: Math.floor(Math.random() * 8) + 2, // replace with API value
// //     };
// //   });
// // }

// // export default function WeekSelector() {
// //   const days = useMemo(() => getTehranWeek(), []);
// //   const [selected, setSelected] = useState(0);

// //   const today = moment().tz('Asia/Tehran');

// //   console.log('mmNow:', today.format('YYYY-MM-DD HH:mm:ss'));
// //   console.log('mmJalali:', today.format('jYYYY/jMM/jDD'));
// //   console.log('mmFormatted:', today.format('jD jMMMM dddd'));
// //   console.log(new Date().toString());
// //   console.log(new Date().toISOString());
// //   console.log(Intl.DateTimeFormat().resolvedOptions());
// //   return (
// //     <div className={styles.container}>
// //       {days.map((day) => (
// //         <button
// //           key={day.id}
// //           className={`${styles.button} ${selected === day.id ? styles.active : ''}`}
// //           onClick={() => setSelected(day.id)}
// //         >
// //           <div className={`${styles.day} ${selected === day.id ? styles.activeText : ''}`}>
// //             {day.dayLabel}
// //           </div>

// //           <div className={`${styles.date} ${selected === day.id ? styles.activeText : ''}`}>
// //             {day.dateLabel}
// //           </div>

// //           <div className={styles.slots}>{day.slots} نوبت</div>
// //         </button>
// //       ))}
// //     </div>
// //   );
// // }
// // ============================
// 'use client';

// import { useMemo, useState } from 'react';
// import moment from 'jalali-moment';
// import momentTz from 'moment-timezone';
// import styles from './styles.module.css';

// moment.locale('fa');

// function getTehranWeek() {
//   // Get the current moment in Tehran
//   const today = moment(momentTz.tz(Date.now(), 'Asia/Tehran')).startOf('day');

//   return Array.from({ length: 7 }, (_, index) => {
//     const date = today.clone().add(index, 'day');

//     return {
//       id: index,
//       dayLabel: index === 0 ? 'امروز' : index === 1 ? 'فردا' : date.format('dddd'),
//       dateLabel: date.format('jD jMMMM'),
//       slots: Math.floor(Math.random() * 8) + 2,
//     };
//   });
// }

// export default function WeekSelector() {
//   const days = useMemo(() => getTehranWeek(), []);
//   const [selected, setSelected] = useState(0);
//   console.log('hh', new Date().toString());
//   console.log('hh', Intl.DateTimeFormat().resolvedOptions().timeZone);
//   console.log('hh', new Date().getTimezoneOffset());
//   console.log(
//     'hh',
//     new Date().toLocaleDateString('fa-IR', {
//       //   year: 'numeric',
//       //   month: 'long',
//       timeZone: 'Asia/Tehran',
//     }),
//   );
//   console.log('hhh', new Date().toISOString());
//   console.log(
//     'hhh',
//     new Intl.DateTimeFormat('en-CA', {
//       timeZone: 'Asia/Tehran',
//       year: 'numeric',
//       month: '2-digit',
//       day: '2-digit',
//       hour: '2-digit',
//       minute: '2-digit',
//       second: '2-digit',
//       hour12: false,
//     }).format(new Date()),
//   );
//   return (
//     <div className={styles.container}>
//       {days?.map((day) => (
//         <button
//           key={day.id}
//           className={`${styles.button} ${selected === day.id ? styles.active : ''}`}
//           onClick={() => setSelected(day.id)}
//         >
//           <div className={`${styles.day} ${selected === day.id ? styles.activeText : ''}`}>
//             {day.dayLabel}
//           </div>

//           <div className={`${styles.date} ${selected === day.id ? styles.activeText : ''}`}>
//             {day.dateLabel}
//           </div>

//           <div className={styles.slots}>{day.slots} نوبت</div>
//         </button>
//       ))}
//     </div>
//   );
// }

// ====================

'use client';

import { useEffect, useMemo, useState } from 'react';
import moment from 'jalali-moment';
import momentTz from 'moment-timezone';
import styles from './styles.module.css';
import { ReserveInfo } from '@/commonTypes';

moment.locale('fa');

function getTehranWeek() {
  const today = moment(momentTz.tz(Date.now(), 'Asia/Tehran')).startOf('day');

  return Array.from({ length: 7 }, (_, index) => {
    const date = today.clone().add(index, 'day');

    return {
      id: index,
      dayLabel: index === 0 ? 'امروز' : index === 1 ? 'فردا' : date.format('dddd'),

      // Display (Shamsi)
      dateLabel: date.format('jD jMMMM'),

      // Shamsi date (e.g. 1405-05-21)
      shamsiDate: date.format('jYYYY-jMM-jDD'),

      // Miladi date (e.g. 2026-08-12)
      miladiDate: date.clone().locale('en').format('YYYY-MM-DD'),

      date,
      slots: Math.floor(Math.random() * 8) + 2,
    };
  });
}

export default function WeekSelector({
  onChange,
  info,
}: {
  onChange: (value: any, key: string) => void;
  info?: ReserveInfo;
}) {
  const days = useMemo(() => getTehranWeek(), []);
  const [selected, setSelected] = useState<number>();

  useEffect(() => {
    if (!info?.date) return;

    // const shamsiDate = moment(info.date, 'YYYY-MM-DD').format('jYYYY-jMM-jDD');

    const selectedDay = days.find((day) => day.miladiDate === info?.date);

    if (selectedDay) {
      setSelected(selectedDay.id);
    }
  }, [info?.date, days]);

  const handleSelect = (day: (typeof days)[number]) => {
    setSelected(day.id);

    // console.log('Selected Gregorian Date:', day.gregorianDate);
    const miladiDate = day.date.clone().locale('en').format('YYYY-MM-DD');

    console.log('miladiDate==========', miladiDate);
    onChange(miladiDate, 'date');

    // Example API call
    /*
    fetch('/api/appointments', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        date: day.gregorianDate,
      }),
    });
    */
  };

  return (
    <>
      <div className={styles.container}>
        {days?.map((day) => (
          <button
            key={day.id}
            className={`${styles.button} ${selected === day.id ? styles.active : ''}`}
            onClick={() => handleSelect(day)}
          >
            <div className={`${styles.day} ${selected === day.id ? styles.activeText : ''}`}>
              {day.dayLabel}
            </div>

            <div className={`${styles.date} ${selected === day.id ? styles.activeText : ''}`}>
              {day.dateLabel}
            </div>

            <div className={styles.slots}>{day.slots} نوبت</div>
          </button>
        ))}
      </div>
      {info?.error?.date && info?.messages?.date && (
        <p className={`inputErrorText`}>{info?.messages.date}</p>
      )}
    </>
  );
}
